<template>
  <div>
    <footer>
      <div class="footer container">


        <div class="footer-center container1300 fonter-height" v-if="!footerShow" style="">

          <!--          <div class="li" v-for="(item,index) in navList" :key="index">-->
          <!--            <a href="javascript:;" @click="navClick(index,item)"> {{item.oname}}</a>-->
          <!--            <a href="javascript:;" v-if="item.children.length>0" v-for="(i,n) in item.children" :key="n"-->
          <!--               @click.stop="nav(i)">-->
          <!--              {{i.oname}}-->
          <!--            </a>-->
          <!--            &lt;!&ndash; <dl v-if="item.children.length>0">-->
          <!--               <dt v-for="(i,n) in item.children" :key="n">-->
          <!--                 <a @click.stop="nav(i)">{{i.oname}}</a>-->
          <!--               </dt>-->
          <!--             </dl> &ndash;&gt;-->
          <!--          </div>-->
          <div class="fonter-div" style="">
            <div style="">
              <img src=".././assets/img/AD0It_LyCRAEGAAgzar-7QUogIiRjAcwJjgq.png">
            </div>
            <div style="">
              <p>电话：{{companyPhone}}</p>
            </div>
          </div>
          <div class="fonter-div" style="border-left: 1px solid #636262;border-right: 1px solid #636262;">
            <div style="">
              <img src=".././assets/img/AD0It_LyCRAEGAAgpqv-7QUo1PLcNjAjODA.png">
            </div>
            <div style="">
              <p style="width: 80%">公司地址：{{companyAddr}}</p>
            </div>
          </div>
          <div class="fonter-div" style="">
            <div style="">
              <img src=".././assets/img/AD0It_LyCRAEGAAgrKv-7QUoyuPqqQYwIzgr.png">
            </div>
            <div style="">
              <p>做设计，放心交给我们</p>
            </div>
          </div>
        </div>

        <!--        <div class="footer-center" v-if="!footerShow">-->
        <!--                    <div class="li" v-for="(item,index) in navList" :key="index">-->
        <!--                      <a href="javascript:;" @click="navClick(index,item)"> {{item.oname}}</a>-->
        <!--                      <a href="javascript:;" v-if="item.children.length>0" v-for="(i,n) in item.children" :key="n"-->
        <!--                        @click.stop="nav(i)">-->
        <!--                        {{i.oname}}-->
        <!--                      </a>-->
        <!-- <dl v-if="item.children.length>0">
           <dt v-for="(i,n) in item.children" :key="n">
             <a @click.stop="nav(i)">{{i.oname}}</a>
           </dt>
         </dl> -->
        <!--                    </div>-->
        <!--          <div class="footer-erweima" style="border-right: 1px solid #a5a2a2;opacity: 0.5">-->
        <!--&lt;!&ndash;            <img src="https://tv.w5258.com/uploads/allimg/20230708/1-230FQ01K6128.jpg" width="100"&ndash;&gt;-->
        <!--&lt;!&ndash;                 alt="易路荣昕公众号二维码"/>&ndash;&gt;-->
        <!--            <i class="iconfont icon-yuyue" style="font-size: 50px;color: #FFF"></i>-->
        <!--            <p >咨询电话：15686118900</p>-->
        <!--            <p >咨询电话：18681989000</p>-->
        <!--          </div>-->
        <!--          <div class="footer-erweima">-->
        <!--            <i class="iconfont icon-daodian" style="font-size: 50px;color: #FFF;opacity: 0.5"></i>-->
        <!--            <p style="opacity: 0.5">联系地址：陕西省咸阳市秦都区</p>-->
        <!--            <p style="opacity: 0.5">北郊天元建材市场南三层（2号楼）3号二楼</p>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="footer-pic" v-if="footerShow">
          <!--          <div class="footer-erweima">-->

          <!--            <img src="https://tv.w5258.com/uploads/allimg/20230708/1-230FQ01K6128.jpg" width="100" alt="易路荣昕公众号二维码" />-->
          <!--            <p>易路荣昕公众号</p>-->
          <!--          </div>-->
          <!--          <div class="footer-erweima">-->
          <!--            <img src="https://tv.w5258.com/uploads/allimg/20221113/1-22111311463Y95.jpg" width="100" alt="易路荣昕抖音号二维码" />-->
          <!--            <p>易路荣昕抖音号</p>-->
          <!--          </div>-->
        </div>
      </div>
      <p class="footer-copyRight">Copyright © 2008-2024 咸阳楚天装饰工程有限公司</p>
    </footer>
  </div>
</template>
<script>
import config from '@/config'
import {
  appone,
  apptwo
} from '@/api/category'
import {selectusetbyflag} from '@/api/index'

export default {
  name: "Footer",
  data() {
    return {
      config: config,
      navList: [],
      footerShow: true,
      companyPhone:'',
      companyAddr:'',
    };
  },
  mounted() {
    this.search()
  },
  methods: {
    search() {
      appone().then(res => {
        // console.log(res.data)
        res.data.forEach(item => {
          item.children = []
          apptwo({
            parid: item.zxid
          }).then(response => {
            if (response.data) {
              item.children = response.data
            }
          })
        })
        this.navList = res.data
      })
      selectusetbyflag('phone').then(res => {
        if (res.code === 200) {
          this.companyPhone = res.msg
        }
      })
      selectusetbyflag('addr').then(res => {
        if (res.code === 200) {
          this.companyAddr = res.msg
        }
      })
    },
    navClick(index, item) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex', index)
      this.menuName = name;
      if (item.oname != '首页') {
        this.$router.push({
          name: item.tzurl,
        })
      } else {
        this.$router.push('/home')
      }
    },
    nav(item) {
      console.log(item)
      this.$router.push({
        name: item.tzurl,
      })
    },
  },
  created() {
    // 判断页面是否在手机端打开
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
      // console.log('当前在手机端');
      // window.location.href = '小程序链接'
      this.footerShow = true
    } else {
      // console.log('当前在PC端');
      this.footerShow = false
    }
  },
};
</script>
<style scoped>
#footer {
  width: 100%;
  //height: 100%;
  color: #fff;
  background: rgb(31 31 31);
  overflow: hidden;
  text-align: center;
}

.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}

.title {
  font-size: 25px;
  margin-bottom: 20px;
}

.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}

.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}

.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}

@media screen and (max-width: 997px) {
  /* footer */
  footer {
    padding-bottom: 0px;
    clear: both;
  }

  .title {
    font-size: 20px;
  }

  .address_tel_fax {
    font-size: 12px;
  }

  .email_wx {

    font-size: 12px;
  }

  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.fonter-height{
  height: 114px;display: flex;align-items: center;justify-content: center;
}
.fonter-div{
  width:30%;text-align: center;
  color: #b6b6b6;
}
.fonter-div>div{
  width:100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 20px;
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue